import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { ProductCard } from "../components/ProductCard";
import { Reveal, Eyebrow } from "../components/Reveal";
import { http } from "../lib/api";

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    const load = (attempt = 0) => {
      http.get("/products", { timeout: 8000 })
        .then((r) => {
          if (!alive) return;
          setProducts(Array.isArray(r.data) ? r.data : []);
          setLoading(false);
        })
        .catch(() => {
          if (!alive) return;
          if (attempt < 3) setTimeout(() => load(attempt + 1), 1500 * (attempt + 1));
          else setLoading(false);
        });
    };
    load();
    return () => { alive = false; };
  }, []);
  return { products, loading };
};

export const ShopGrid = () => {
  const { search } = useLocation();
  const urlCat = new URLSearchParams(search).get("cat");
  const { products, loading } = useProducts();
  const [cat, setCat] = useState(urlCat || "All");
  useEffect(() => {
    if (urlCat) setCat(urlCat);
  }, [urlCat]);
  const cats = useMemo(() => ["All", ...new Set(products.map((p) => p.category))], [products]);
  const shown = cat === "All" ? products : products.filter((p) => p.category === cat);

  return (
    <section id="shop" className="px-5 py-24 md:px-12 md:py-36" data-testid="shop-section">
      <div className="mx-auto max-w-[1600px]">
        <Reveal className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <div>
            <Eyebrow>Drop 01 / {products.length} pieces</Eyebrow>
            <h2 className="mt-4 font-display text-6xl font-black uppercase leading-[0.85] tracking-tight md:text-8xl">The<br />Catalogue</h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="category-filter">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase()}`}
                onClick={() => setCat(c)}
                className={`border px-4 py-2 font-mono text-xs uppercase tracking-widest transition-colors ${cat === c ? "border-[#00FF66] bg-[#00FF66] text-black" : "border-white/15 text-zinc-300 hover:border-white/50"}`}
              >
                {c}
              </button>
            ))}
          </div>
        </Reveal>
        {loading && <p className="mt-16 font-mono text-sm uppercase text-zinc-400">Loading drop…</p>}
        {!loading && !products.length && <p className="mt-16 font-mono text-sm uppercase text-zinc-400">Catalogue unavailable right now. Check back soon.</p>}
        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((p, i) => <ProductCard key={p.slug} p={p} index={i} />)}
        </div>
      </div>
    </section>
  );
};
